import { C } from '../../theme/palette';

export const Card = ({ children, style = {}, onClick }) => (
  <div
    onClick={onClick}
    style={{
      background: C.white,
      border: '1px solid ' + C.border,
      borderRadius: 12,
      overflow: 'hidden',
      boxShadow: '0 1px 2px rgba(15,23,42,.04)',
      ...style,
    }}
  >
    {children}
  </div>
);
